export interface BulkQuotesForm {
  files: File[];
}

export const defaultValues: BulkQuotesForm = {
  files: [],
};
